import { _ } from '@splunk/ui-utils/i18n';
import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Item class to inform that it can redirect to a custom url based on item events
 * @param {LayoutItem} Item The item to enhance
 */
export const withCustomUrl: PresetHOC<{
    canSetCustomUrl?: boolean;
    interactionsFilterMetadata?: string[];
}> = (Item) => {
    Item.canSetCustomUrl = true;
    Item.interactionsFilterMetadata ??= [];
    Item.interactionsFilterMetadata.push(_('Link to custom URL'));

    return Item;
};
